import React from "react";
import { useHwaddrAndNetworkIdFromRouter, useZones } from "../store/panelsSlice.js";
                
export const ZoneSelector = props => {
    const zones = useHwaddrAndNetworkIdFromRouter(useZones);
    return (
        <select className="form-control" value={props.value} onChange={props.onChange} disabled={props.disabled}>
            {zones.map(zone => <option key={zone.id} value={zone.id}>{zone.name}</option>)}
        </select>
    );
}